<script lang="ts">
	import { quadInOut } from 'svelte/easing';
	import { scale } from 'svelte/transition';
	import GradientBorder from '$lib/util/GradientBorder.svelte';
	import { clickOutside } from '../directives/clickOutside';
	import MoreDropDownItem from './MoreDropDownItem.svelte';

	let showMore = false;

	const toggleShowMore = () => {
		showMore = !showMore;
	};

	const ignoreElement: string = '#IgnoreElement';
</script>

<div class="relative" id="IgnoreElement">
	<button
		class="cursor-pointer px-2 py-1 rounded-md flex gap-2 items-center flex-nowrap hover:bg-fx-grey-600 hover:bg-opacity-50 transition ease-in"
		on:click={() => (showMore = !showMore)}
		on:keydown={() => (showMore = !showMore)}
		use:clickOutside = {ignoreElement}
		on:outclick={() => (showMore = false)}
	>
		<div class="text-fx-grey-400 font-medium text-sm whitespace-nowrap">More</div>
		<img
			src="down-arrow.png"
			alt=""
			class="w-3 transition-transform duration-300 ease-in-out h-min"
			class:flip-arrow={showMore}
		/>
	</button>

	{#if showMore}
		<div
			class="w-fit absolute duration-500 rounded-lg squircle-lg bg-fx-gradient-7 left-0 top-12 z-50"
			transition:scale={{
				duration: 100,
				delay: 0,
				opacity: 0.9,
				start: 0.97,
				easing: quadInOut
			}}
		>
			<GradientBorder
				gradient="bg-fx-gradient-6"
				paddingClass="p-px"
				outerClassList=""
				innerClassList="flex flex-col items-center bg-fx-black squircle-lg"
			>
				<div class="bg-fx-gradient-8-50 px-4 py-2 flex flex-col gap-2">
					<slot />
				</div>
			</GradientBorder>
		</div>
	{/if}
</div>

<style>
	.flip-arrow {
		transform: rotate(180deg);
	}
</style>
